import LocalizedLink from '@components/Localization/LocalizedLink'
import { RolexContainer } from '@components/_rolex/Container'
import { Image } from '@components/gassan-ui'
import { Button } from '@components/old-rolex-ui'
import { Heading } from '@components/rolex-ui/Heading'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

type LandingPageHeroProps = {
  mobileImage: AssetsElement
  desktopImage: AssetsElement
  title: string
  buttonText: string
}

export const LandingPageHero: FC<LandingPageHeroProps> = ({
  mobileImage,
  desktopImage,
  title,
  buttonText,
}) => {
  const { t } = useTranslation('navigation')
  return (
    <div className={cn('relative')}>
      <Image
        className="aspect-[13/20] w-full object-cover md:aspect-[12/5]"
        sources={[
          getKontentImage(mobileImage.value[0].url, { width: 768 }),
          getKontentImage(desktopImage.value[0].url, { width: 1200 }),
          getKontentImage(desktopImage.value[0].url, { width: 2000 }),
        ]}
        alt={mobileImage.value[0].description || ''}
      />
      <RolexContainer className="absolute bottom-8 left-0 right-0 z-[2] grid w-full grid-cols-12 md:bottom-auto md:top-1/2 md:-translate-y-1/2">
        <div className={cn('col-span-12', 'md:col-span-5')}>
          <Heading variant="headline70" as="h1" className="!mb-5 text-white">
            {title}
          </Heading>
          <LocalizedLink href={t(`rcpo.selection.url`, { ns: 'navigation' })}>
            <Button>{buttonText}</Button>
          </LocalizedLink>
        </div>
      </RolexContainer>
    </div>
  )
}
